import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { kycStatusCheck } from '../../../../slices/eligibility/eligibilitySlice';
import Loader from '../../../common/Loader'
import DealerSelfie from './dealerSelfie'
import CommonKyc from './kyc'
import Summary from './summary';

function Kyc() {
    const { subStage, stage } = useSelector(state => state.eligibility)
    const { referenceId } = useSelector(state => state.dashboard)
    const kycData = useSelector(state => state?.eligibility?.kycData)
    const [data, setData] = useState({ documentType: "", documentNumber: "", status: "", jsonData: {} })
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const fetchKycData = async () => {
            if (stage === 'kyc' && referenceId && (!kycData || Object.keys(kycData).length === 0)) {
                setLoader(true)
                try {
                    let response = await dispatch(kycStatusCheck({ "reference_id": referenceId }))
                    if (response?.payload?.response_code === 'S100') {
                        // Success case - loader already set to false
                    } else {
                        // Handle non-success response codes
                        console.error('KYC status check failed:', response?.payload?.response_code)
                    }
                } catch (error) {
                    console.error('KYC status check error:', error)
                } finally {
                    setLoader(false)
                }
            }
        };
        fetchKycData();
    }, [stage, kycData, referenceId, dispatch])

    return (
        <>
            {(subStage === 'kyc-in-progress' || subStage === 'customer_selfie') && <CommonKyc data={data} setData={setData} />}
            {subStage === 'fos_selfie' && <DealerSelfie data={data} setData={setData} />}
            {loader === true && <Loader />}
        </>
    )
}

export default Kyc